// src/context/ReviewsContext.js - Simple Reviews Context
import React, { createContext, useContext, useState } from 'react';

const ReviewsContext = createContext();

export const ReviewsProvider = ({ children }) => {
  const [reviews, setReviews] = useState([]);

  const addReview = (review) => {
    setReviews(prev => [...prev, { ...review, id: Date.now() }]);
  };

  const getAverageRating = (itemId) => {
    const itemReviews = reviews.filter(review => review.itemId === itemId);
    if (itemReviews.length === 0) return 4.5; // Default rating
    return itemReviews.reduce((sum, review) => sum + review.rating, 0) / itemReviews.length;
  };

  const value = {
    reviews,
    addReview,
    getAverageRating
  };

  return (
    <ReviewsContext.Provider value={value}>
      {children}
    </ReviewsContext.Provider>
  );
};

export const useReviews = () => {
  const context = useContext(ReviewsContext);
  if (!context) {
    throw new Error('useReviews must be used within a ReviewsProvider');
  }
  return context;
};